/* ==========================================================================
   Rooster Bus, Size Guide (progressive enhancement only)
   Every chart is already in the HTML. This file adds:
     · brand search + category filter (hides non-matching brand blocks)
     · the A-Z rail, built from what's visible
     · chart tabs for brands with more than one chart
   With JS off, every chart on the page is visible and readable.
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-rsg]');
  if (!root) return;

  var brands = [].slice.call(root.querySelectorAll('.rsg__brand'));
  if (!brands.length) return;

  /* ---------- chart tabs ---------- */
  root.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.rsg__tab') : null;
    if (!tab) return;
    var block = tab.closest('.rsg__brand');
    [].forEach.call(block.querySelectorAll('.rsg__tab'), function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });
    [].forEach.call(block.querySelectorAll('.rsg__chart'), function (c) {
      c.hidden = c.getAttribute('data-i') !== tab.getAttribute('data-i');
    });
  });

  /* ---------- hub-only: search, filter, rail ---------- */
  var rail = root.querySelector('[data-rsg-rail]');
  if (!rail) return;

  var input = root.querySelector('[data-rsg-q]');
  var chips = root.querySelector('[data-rsg-chips]');
  var empty = root.querySelector('[data-rsg-empty]');
  var state = { cat: 'all', q: '' };

  function paint() {
    var shown = 0;
    var links = '';
    brands.forEach(function (b) {
      var okCat = state.cat === 'all' || b.getAttribute('data-cat') === state.cat;
      var okQ = !state.q || b.getAttribute('data-name').indexOf(state.q) > -1;
      var ok = okCat && okQ;
      b.hidden = !ok;
      if (ok) {
        shown++;
        var name = b.querySelector('.rsg__brand-name').textContent;
        links += '<a href="#' + b.id + '">' + name + '</a>';
      }
    });
    rail.innerHTML = links;
    if (empty) empty.hidden = shown > 0;
  }

  /* Filtering hides brands, so the page can get dramatically shorter. If the
     shopper was scrolled deep into a brand (common on mobile, where they pick a
     brand first) the old scroll position ends up past the new bottom and the
     browser dumps them in the footer. After any filter change, put them back at
     the top of the results so they can choose from what's left. */
  function backToResults() {
    /* Run after the browser has finished reflowing and clamping the scroll
       position to the now-shorter document — measuring during that reflow gave
       a bogus target and the shopper stayed stranded in the footer. */
    setTimeout(function () {
      var wrap = root.querySelector('.rsg__wrap') || root.querySelector('.rsg__bar');
      if (!wrap) return;
      var cs = getComputedStyle(document.documentElement);
      var hdrMax = parseInt(cs.getPropertyValue('--rsg-hdr-max'), 10) || 0;
      var bar = parseInt(cs.getPropertyValue('--rsg-bar'), 10) || 0;
      var target = Math.max(0, wrap.getBoundingClientRect().top + window.pageYOffset - hdrMax - bar);
      if (window.pageYOffset <= target + 4) return;   /* already at/above results */
      /* smooth scrolling is suspended in hidden tabs, so only ask for it when
         the page is actually on screen; otherwise jump. */
      var behavior = document.visibilityState === 'visible' ? 'smooth' : 'auto';
      try {
        window.scrollTo({ top: target, behavior: behavior });
      } catch (e) {
        window.scrollTo(0, target);
      }
    }, 0);
  }

  /* a brand chosen in the mobile picker may not survive the next filter */
  function resetJump() {
    var sel = root.querySelector('[data-rsg-jump]');
    if (sel) sel.value = '';
  }

  if (input) {
    input.addEventListener('input', function () {
      state.q = this.value.toLowerCase().trim();
      paint();
      resetJump();
      backToResults();
    });
  }
  if (chips) {
    chips.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.rsg__chip') : null;
      if (!chip) return;
      state.cat = chip.getAttribute('data-cat');
      [].forEach.call(chips.querySelectorAll('.rsg__chip'), function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      paint();
      resetJump();
      backToResults();
    });
  }

  /* keep the rail marker in sync with what you're reading */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        [].forEach.call(rail.querySelectorAll('a'), function (a) {
          a.setAttribute('aria-current', a.getAttribute('href') === '#' + en.target.id ? 'true' : 'false');
        });
      });
    }, { rootMargin: '-70px 0px -75% 0px' });
    brands.forEach(function (b) { io.observe(b); });
  }

  paint();
})();

/* ---------------------------------------------------------------------------
   Rooster (aug 14): the generated captions all say "scroll sideways for every
   measurement", but narrow charts (bottoms, one-size headwear) don't scroll.
   Strip that clause unless the table really does overflow its wrapper, and
   re-check on resize / tab change since overflow is viewport-dependent.
--------------------------------------------------------------------------- */
(function () {
  var HINT = /\s*[·\u00b7]\s*scroll sideways for every measurement/i;

  function sync() {
    [].forEach.call(document.querySelectorAll('.rsg__tablewrap'), function (wrap) {
      var table = wrap.querySelector('.rsg__table');
      var cap = wrap.parentNode && wrap.parentNode.querySelector('.rsg__cap');
      if (!table || !cap) return;

      if (cap.dataset.rsgFull === undefined) cap.dataset.rsgFull = cap.textContent;
      var full = cap.dataset.rsgFull;
      var overflows = table.scrollWidth > wrap.clientWidth + 1;
      var wanted = overflows ? full : full.replace(HINT, '');
      if (cap.textContent !== wanted) cap.textContent = wanted;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.__rsgCapT);
    window.__rsgCapT = setTimeout(sync, 150);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.rsg__tab, .rb-psg__summary, .rb-csg__summary')) {
      setTimeout(sync, 60);
    }
  });
  window.rsgSyncCaptions = sync;
})();

/* ---------------------------------------------------------------------------
   Rooster (aug 14): print the column name next to every value so the mobile
   card layout (see rooster-size-guide.css) reads without a horizontal scroll.
--------------------------------------------------------------------------- */
(function () {
  function label() {
    [].forEach.call(document.querySelectorAll('.rsg__table'), function (t) {
      if (t.dataset.rsgLabelled === '1') return;
      var heads = [].map.call(t.querySelectorAll('thead th'), function (th) {
        return th.textContent.trim();
      });
      if (!heads.length) return;
      [].forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
        var rowSize = tr.children[0] ? tr.children[0].textContent.trim() : '';
        [].forEach.call(tr.children, function (cell, i) {
          if (heads[i] && !cell.hasAttribute('data-rsg-label')) {
            cell.setAttribute('data-rsg-label', heads[i]);
          }
          /* some charts repeat the size in an "alt size" column (7Diamonds
             lists "Small" twice). On the mobile card that's a wasted row, so
             flag exact duplicates and let CSS drop them. */
          if (i > 0 && cell.textContent.trim() === rowSize && rowSize !== '') {
            cell.classList.add('rsg--dupe');
          }
        });
      });
      t.dataset.rsgLabelled = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', label);
  } else {
    label();
  }
  window.rsgLabelCells = label;
})();

/* ---------------------------------------------------------------------------
   Rooster (aug 14):
   · measure the theme's sticky header so the filter bar sits under it and
     #brand anchors don't land mid-chart (--rsg-hdr / --rsg-bar)
   · drive the mobile brand <select>
--------------------------------------------------------------------------- */
(function () {
  var root = document.documentElement;

  var lastHdr = -1;

  /* The theme header auto-hides on scroll-down and slides back on scroll-up.
     A fixed offset left the filter bar floating with content sliding through
     the gap, so follow the header's real visible edge instead:
       header hidden  -> 0, bar sits flush at the top
       header shown   -> its height, bar tucks underneath it
     --rsg-hdr-max stays the full height and is what anchor scroll-margin uses,
     so a link can never land beneath a header that's about to reappear. */
  function measure() {
    var hdr = document.querySelector('header.header, .js-header-sticky, header');
    var bar = document.querySelector('.rsg__bar');
    var hMax = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
    var b = bar ? Math.round(bar.getBoundingClientRect().height) : 57;
    root.style.setProperty('--rsg-hdr-max', hMax + 'px');
    root.style.setProperty('--rsg-bar', b + 'px');
    track();
  }

  function track() {
    var hdr = document.querySelector('header.header, .js-header-sticky, header');
    if (!hdr) return;
    var r = hdr.getBoundingClientRect();
    var visible = Math.max(0, Math.min(Math.round(r.height), Math.round(r.bottom)));
    if (Math.abs(visible - lastHdr) > 1) {
      lastHdr = visible;
      root.style.setProperty('--rsg-hdr', visible + 'px');
    }
  }

  /* Timestamp throttle rather than requestAnimationFrame: rAF is suspended in
     background tabs, and a suspended frame would latch the "ticking" guard and
     stop the header from ever being re-measured after the tab woke up.
     track() is a single getBoundingClientRect, so 20fps is plenty. */
  var lastRun = 0;
  function onScroll() {
    var now = Date.now();
    if (now - lastRun < 50) return;
    lastRun = now;
    track();
  }

  function wireJump() {
    var sel = document.querySelector('[data-rsg-jump]');
    var rail = document.querySelector('[data-rsg-rail]');
    if (!sel || !rail) return;

    function fill() {
      var links = [].slice.call(rail.querySelectorAll('a'));
      var cur = sel.value;
      sel.innerHTML = '<option value="">Jump to a brand\u2026</option>' +
        links.map(function (a) {
          return '<option value="' + a.getAttribute('href') + '">' + a.textContent + '</option>';
        }).join('');
      if (cur) sel.value = cur;
    }

    fill();
    /* the rail is re-rendered whenever search/category changes */
    new MutationObserver(fill).observe(rail, { childList: true });

    sel.addEventListener('change', function () {
      var id = sel.value;
      if (!id) return;
      var el = document.querySelector(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', id);
      }
    });
  }

  function init() { measure(); wireJump(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.__rsgHdrT);
    window.__rsgHdrT = setTimeout(measure, 150);
  });
  window.addEventListener('load', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('visibilitychange', measure);
  window.rsgSyncHeader = track;   /* exposed for debugging / verification */
})();

/* ---------------------------------------------------------------------------
   Rooster (aug 14): open the chart tab that matches the product.
   A Katin "Ward Short" (type Shorts, description says "elastic waistband")
   lands on BOTTOMS: ELASTIC WAIST instead of the default TOPS tab.
   Matching is done on word boundaries: an earlier version used Liquid's
   substring `contains` and matched "hat" inside "that", which sent every
   wordy product into the headwear branch.
--------------------------------------------------------------------------- */
(function () {
  var CATS = [
    { name: 'eyewear',   hint: ['sunglass', 'sunglasses', 'eyewear', 'shades'],
      label: ['eyewear', 'frame'] },
    { name: 'headwear',  hint: ['hat', 'cap', 'snapback', 'trucker', 'beanie', 'fitted'],
      label: ['headwear', 'hat'] },
    { name: 'underwear', hint: ['boxer', 'brief', 'underwear'],
      label: ['underwear', 'boxer', 'brief'] },
    { name: 'bottoms',   hint: ['short', 'shorts', 'pant', 'pants', 'jean', 'jeans', 'denim', 'chino',
                                'trouser', 'trunk', 'trunks', 'boardshort', 'jogger', 'swim', 'bottom', 'bottoms'],
      label: ['bottom', 'pant', 'short', 'jean', 'denim', 'trunk', 'swim', 'jogger', 'waist'] },
    { name: 'tops',      hint: ['shirt', 'tee', 'tees', 't-shirt', 'polo', 'henley', 'flannel', 'hoodie',
                                'sweater', 'sweatshirt', 'jacket', 'overshirt', 'crewneck', 'top', 'tops'],
      label: ['top', 'shirt', 'tee', 'polo', 'henley', 'flannel', 'hoodie', 'sweater', 'jacket'] }
  ];
  var QUALS = ['elastic', 'drawstring', 'drawcord', 'vintage', 'relaxed', 'slim', 'straight',
               'bootcut', 'athletic', 'tall'];

  /* Garment type beats fit wording. A woven "Sundown Short Sleeve Shirt" whose
     copy says "relaxed" must not land on RELAXED FIT T-SHIRTS — it isn't a tee.
     If a tab names a garment the product isn't, rule it out. */
  var SPECIFICS = [
    { label: ['t-shirt', 'tee'],        hay: ['tee', 'tees', 't-shirt', 't-shirts', 'tshirt'] },
    { label: ['henley'],                hay: ['henley', 'henleys'] },
    { label: ['polo'],                  hay: ['polo', 'polos'] },
    { label: ['flannel'],               hay: ['flannel', 'flannels'] },
    { label: ['hoodie'],                hay: ['hoodie', 'hooded', 'hoody'] },
    { label: ['sweater'],               hay: ['sweater', 'knit', 'pullover'] },
    { label: ['jacket'],                hay: ['jacket', 'coat'] },
    { label: ['pant'],                  hay: ['pant', 'pants', 'trouser', 'trousers', 'chino', 'chinos', 'jean', 'jeans', 'denim'] },
    { label: ['short'],                 hay: ['short', 'shorts', 'trunk', 'trunks', 'boardshort'] },
    { label: ['swim', 'trunk'],         hay: ['swim', 'trunk', 'trunks', 'boardshort'] },
    { label: ['button-up', 'button up'], hay: ['button-up', 'button up', 'buttondown', 'button-down', 'woven', 'shirt'] }
  ];

  function wordIn(hay, word) {
    var esc = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[^a-z])' + esc + '([^a-z]|$)', 'i').test(hay);
  }

  function pick(psg) {
    var clean = function (v) {
      /* "Short Sleeve Shirt" describes a sleeve, not a pair of shorts */
      return (v || '').toLowerCase().replace(/(short|long)\s+sleeve/g, ' ');
    };
    var hay = clean(psg.getAttribute('data-hay'));          /* identity */
    var desc = clean(psg.getAttribute('data-hay-desc'));    /* attributes only */
    var both = hay + ' ' + desc;
    if (!hay && !desc) return;
    var tabs = [].slice.call(psg.querySelectorAll('.rsg__tab'));
    if (tabs.length < 2) return;                 /* single chart, nothing to choose */
    if (psg.dataset.rsgTabPicked === '1') return;

    /* score every category, don't just take the first that matches */
    var best = null;
    CATS.forEach(function (c) {
      var n = 0;
      c.hint.forEach(function (h) { if (wordIn(hay, h)) n++; });
      if (n === 0) { c.hint.forEach(function (h) { if (wordIn(desc, h)) n += 0.25; }); }
      if (n > 0 && (!best || n > best.n)) best = { cat: c, n: n };
    });
    if (!best) return;
    var cat = best.cat;

    var cands = tabs.filter(function (t) {
      var l = t.textContent.toLowerCase();
      for (var k = 0; k < cat.label.length; k++) {
        if (l.indexOf(cat.label[k]) > -1) return true;
      }
      return false;
    });
    if (!cands.length) return;

    var chosen = cands[0], bestScore = -Infinity;
    cands.forEach(function (t) {
      var l = t.textContent.toLowerCase(), score = 0;

      /* garment type first, and it's decisive */
      SPECIFICS.forEach(function (sp) {
        var named = sp.label.some(function (w) { return l.indexOf(w) > -1; });
        if (!named) return;
        /* identity only — the description saying "wear it with a tee" must not
           convince us this shirt is a t-shirt */
        var isIt = sp.hay.some(function (w) { return wordIn(hay, w); });
        score += isIt ? 4 : -6;
      });

      /* then fit wording, as a tiebreak only */
      QUALS.forEach(function (q) {
        var inLabel = l.indexOf(q) > -1;
        if (inLabel && wordIn(both, q)) score += 2;
        else if (inLabel) score -= 1;
      });

      if (score > bestScore) { bestScore = score; chosen = t; }
    });

    psg.dataset.rsgTabPicked = '1';
    if (chosen && chosen.getAttribute('aria-selected') !== 'true') chosen.click();
  }

  function run() {
    [].forEach.call(document.querySelectorAll('.rb-psg[data-hay]'), pick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.rsgPickTab = run;
})();
